import { getISODay } from 'date-fns';
import { formatInTimeZone, toZonedTime, fromZonedTime } from 'date-fns-tz';

export const RESTAURANT_TIMEZONE = 'Europe/Warsaw';

/**
 * Czy obie daty przypadają na ten sam dzień w strefie Warszawa.
 */
export function isSameDayInWarsaw(dateLeft: Date, dateRight: Date): boolean {
  return (
    formatInTimeZone(dateLeft, RESTAURANT_TIMEZONE, 'yyyy-MM-dd') ===
    formatInTimeZone(dateRight, RESTAURANT_TIMEZONE, 'yyyy-MM-dd')
  );
}

/**
 * Dzień tygodnia (1–7) w strefie restauracji – do dopasowania opening_hours.
 */
export function getISODayInWarsaw(date: Date): number {
  return getISODay(toZonedTime(date, RESTAURANT_TIMEZONE));
}

/**
 * Tworzy Date reprezentujący podany moment w strefie Warszawa.
 * Działa poprawnie niezależnie od strefy czasowej użytkownika.
 */
export function createWarsawDate(
  year: number,
  month: number,
  day: number,
  hour: number,
  minute: number
): Date {
  const naiveDate = new Date(year, month, day, hour, minute, 0);
  return fromZonedTime(naiveDate, RESTAURANT_TIMEZONE);
}

/**
 * Zwraca datę w strefie Warszawa – do użycia z addMinutes itp.
 * day – dowolna data (np. z pickera), minuteOffset – minuty od północy w Warszawie.
 */
export function toWarsawSlot(day: Date, minuteOffset: number): Date {
  const dayInWarsaw = toZonedTime(day, RESTAURANT_TIMEZONE);
  const y = dayInWarsaw.getFullYear();
  const m = dayInWarsaw.getMonth();
  const d = dayInWarsaw.getDate();
  const hour = Math.floor(minuteOffset / 60);
  const minute = minuteOffset % 60;
  return createWarsawDate(y, m, d, hour, minute);
}

/** Data w formacie dd.MM.yyyy w strefie Warszawa (do podsumowania rezerwacji). */
export function formatDateWarsaw(date: Date): string {
  return formatInTimeZone(date, RESTAURANT_TIMEZONE, 'dd.MM.yyyy');
}

/** Godzina w formacie HH:mm w strefie Warszawa (do podsumowania rezerwacji). */
export function formatTimeWarsaw(date: Date): string {
  return formatInTimeZone(date, RESTAURANT_TIMEZONE, 'HH:mm');
}
